import React from "react";
import cx from 'classnames';

import { SPREADSHEET_TABLE_CONSTANTS, SpreadsheetTableColumn, SpreadsheetTableColumnId, SpreadsheetTableColumnName, SpreadsheetTableDefaultDataItem, SpreadsheetTableSelectionState } from "../../../../table.types";
import { RowSelectionState } from "../../../../utils/selection.utils";
import { Cell } from "./components/cell";
import { Flex } from "@common/components/Flex";

import './row.styles.scss';

export type RowProps = {
  columnsWidth: Record<SpreadsheetTableColumnId, number>;
  style?: React.CSSProperties;
  className?: string;
  columns: Array<SpreadsheetTableColumn>;
  columnIds: Array<SpreadsheetTableColumnId>;
  dataItem: SpreadsheetTableDefaultDataItem;
  rowIndex: number;
  spreadsheetId?: number;
  selectionState: SpreadsheetTableSelectionState;
  rowSelectionState?: RowSelectionState;
  onCellMouseDown: (rowIndex: number, columnId: SpreadsheetTableColumnId, dataItem: SpreadsheetTableDefaultDataItem, columnName: SpreadsheetTableColumnName, event?: React.MouseEvent) => void;
  onCellMouseEnter: (rowIndex: number, columnId: SpreadsheetTableColumnId) => void;
  onCellMouseUp: () => void;
  isCellSelected: (rowIndex: number, columnId: SpreadsheetTableColumnId) => boolean;
  onCellValueChange?: (rowIndex: number, columnId: SpreadsheetTableColumnId, value: string | number, popPreviousUndo?: boolean) => void;
  setCellToUpdate: React.Dispatch<React.SetStateAction<{ rowIndex: number, columnId: number, newValue: string | number } | null>>;
  onActivateSpreadsheet?: () => void;
};

export const Row: React.FC<RowProps> = React.memo((props) => {
  const { style, className, columns, columnIds, dataItem, columnsWidth, rowIndex, selectionState, rowSelectionState, onCellMouseDown, onCellMouseEnter, onCellMouseUp, isCellSelected, onCellValueChange, setCellToUpdate } = props;

  return (
    <Flex style={style} className={cx('SpreadsheetDetailsSpreadsheetResultTable__body__row', className)}>
      {columns.map((column, index) => {
        const isRowCount = column.id === SPREADSHEET_TABLE_CONSTANTS.ROW_COUNT_FIELD_ID;
        const uniqueKey = `${column.id}-${index}`;
        return (
            <Cell
                columnWidth={columnsWidth[column.id] ?? (isRowCount ? 50 : 150)}
                key={uniqueKey}
                column={column}
                columnIds={columnIds}
                uiColumnId={index}
                spreadsheetId={props.spreadsheetId as any}
                dataItem={dataItem}
                rowIndex={rowIndex}
                selectionState={selectionState}
                rowSelectionState={rowSelectionState}
                onCellMouseDown={onCellMouseDown}
                onCellMouseEnter={onCellMouseEnter}
                onCellMouseUp={onCellMouseUp}
                isCellSelected={isCellSelected}
                allColumns={columns} // Pass all columns for color logic
                className={isRowCount ? 'SpreadsheetDetailsSpreadsheetResultTable__first-column' : undefined}
                onCellValueChange={onCellValueChange}
                setCellToUpdate={setCellToUpdate}
                onActivateSpreadsheet={props.onActivateSpreadsheet}
            />
        );
      })}
    </Flex>
  );
});